<template>
    <main id="profileSettingsPage" class="container mb-3">
      <div class="row">
        <CustomerProfileNavComponent id="sideNav"
                                     class="col-lg-4 col-sm-12 side-nav"
        ></CustomerProfileNavComponent>
        <div class="col-lg-8 col col-sm-12 profile-page">
          <div class="profile-settings__main-wrapper">
            <div class="profile-settings__header-wrapper">
              <h3 class="profile-settings__header">{{ $t('settings') }}</h3>
            </div>

            <div v-for="setting in settings" class="profile-settings__setting">
              <div class="profile-settings__setting-wrapper">
                <div class="profile-settings__setting"></div>
                <CheckBoxComponent @click="setting.value = !setting.value"
                                   :state="setting.value">
                  <template #checkbox-text>
                    <label :for="setting.key">
                      {{ $t(setting.key) }}
                    </label>
                  </template>
                </CheckBoxComponent>
        <!--        <span class="profile-settings__setting-text">{{ $t(setting.key) }}</span>-->
              </div>
            </div>
            <button class="profile-settings__save-button" @click="save()" :disabled="loading" :class="{'less-padding-06': loading}">
              {{ $t('save') }} <span v-if="loading" class="customer-loader"></span>
            </button>

            <!-- Success and error messages -->
            <div class="mt-2" v-if="errors.length || success">
              <template v-for="error in errors">
                <div class="font-small error-color">
                  {{ $t(error) }}
                </div>
              </template>

              <template v-if="success">
                <div class="font-small success-color">
                  {{ $t('saved') }}
                </div>
              </template>
            </div>

          </div>
        </div>
      </div>
  </main>

</template>

<script lang="ts">
import './profileSettingsPage.scss';

import {useStore} from "vuex";

import axios from "axios";
import {defineComponent} from "vue";
import apiService from "../../services/apiService";
import type {ICustomerGetSettingsResponse} from "@/interfaces/ICustomerGetSettingsResponse.interface";

// @ts-ignore
import CustomerProfileNavComponent from "../../components/CustomerProfileNav/CustomerProfileNavComponent.vue";
// @ts-ignore
import CheckBoxComponent from "../../components/CheckBox/CheckBoxComponent.vue";

export default defineComponent({
  name: "ProfileSettingsPage",
  components: {
    CheckBoxComponent,
    CustomerProfileNavComponent,
  },
  setup() {
    const store = useStore();

    return {
      store
    }
  },
  data() {
    return {
      settings: {},
      loading: false,
      success: false,
      errors: <string[]>[]
    }
  },
  mounted() {
    axios.post(apiService.customerGetSettings())
      .then(response => {
        this.settings = <ICustomerGetSettingsResponse>response.data;
      });
  },
  methods: {
    save() {
      if (this.loading) {
        return;
      }
      this.loading = true;

      this.success = false;
      this.errors = [];

      axios.post(apiService.customerSetSettings(), this.settings)
          .then(response => {
            this.success = true;

            setTimeout(() => {
              this.success = false;
            }, 3000);
          })
          .catch(error => {
            this.errors = [];

            const response = error.response;

            if (response.status === 422) {
              const data =  response.data.errors;

              for (const prop in data) {
                if (!data.hasOwnProperty(prop)) {
                  continue;
                }
                for (const error of data[prop]) {
                  this.errors.push(prop + '.' + error);
                }
              }

              return;
            }

            this.errors.push('key_loading_error');
            console.error(error);

          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
})
</script>

<style scoped>

</style>